function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

/**
 * The `TileAddon` component is used to render either a `FontIcon` or an `Avatar`
 * next to the `ListTileText` for a `ListItem`.
 */

var TileAddon = function (_PureComponent) {
  _inherits(TileAddon, _PureComponent);
  function TileAddon() {
    _classCallCheck(this, TileAddon);
    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }
  TileAddon.prototype.render = function render() {
    var _cn;
    var _props = this.props,
      icon = _props.icon,
      avatar = _props.avatar,
      active = _props.active,
      activeClassName = _props.activeClassName,
      style = _props.style,
      className = _props.className;
    if (!icon && !avatar) {
      return null;
    }
    var avatarIcon = false;
    if (avatar) {
      var avatarChild = React.Children.only(avatar);
      if (avatarChild.props.iconSized) {
        avatarIcon = true;
      }
    }
    return React.createElement('div', {
      style: style,
      className: cn('md-tile-addon', (_cn = {
        'md-tile-addon--icon': icon || avatarIcon,
        'md-tile-addon--avatar': avatar && !avatarIcon
      }, _cn[activeClassName] = active, _cn), className)
    }, icon || avatar);
  };
  return TileAddon;
}(PureComponent);
TileAddon.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  active: PropTypes.bool,
  activeClassName: PropTypes.string,
  icon: PropTypes.node,
  avatar: PropTypes.node
};
export default TileAddon;